/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type JobUpdateStatus = typeof JobUpdateStatus[keyof typeof JobUpdateStatus] | null;


export const JobUpdateStatus = {
  draft: 'draft',
  active: 'active',
  closed: 'closed',
} as const;
